import { useMantineTheme } from "@mantine/core";
import { SpacingPxs } from "theme";

import Flex from "components/Flex";
import Text from "components/Text";

import { Tip } from "./Tip";
import { TipVariant, TipsSize } from "./types";

type TipsProps = {
  tips: TipVariant[];
  title?: string;
  description?: string;
  borderRadius?: string;
  gap?: SpacingPxs;
  px?: SpacingPxs;
  py?: SpacingPxs;
  size?: TipsSize;
};

export const Tips = ({
  tips,
  title,
  description,
  borderRadius = "4px",
  gap = 8,
  px = 12,
  py = 12,
  size = "small",
}: TipsProps) => {
  const theme = useMantineTheme();

  return (
    <Flex px={px} py={py} style={{ backgroundColor: theme.other.primary[5], borderRadius }}>
      {title && (
        <Text sizeVariant="lg" weight={500}>
          {title}
        </Text>
      )}
      {description && (
        <Text sizeVariant="md" weight={400} mt={4}>
          {description}
        </Text>
      )}
      <Flex as="ul" mt={gap} gap={gap}>
        {tips.map((tip) => (
          <Tip key={tip} variant={tip} sizeVariant={size === "small" ? "base" : "md"} />
        ))}
      </Flex>
    </Flex>
  );
};
